/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acceptall1Inputs */



/**
* | output |
* | --- |
* | "Accept all" |
*
* @param {Acceptall1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const acceptall1 = /** @type {((inputs?: Acceptall1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acceptall1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Accept all")
	return /** @type {LocalizedString} */ ("Alle akzeptieren")
});
export { acceptall1 as "acceptAll" }